import {
  Box,
  Button,
  Dialog,
  DialogContent,
  FormControlLabel,
  Stack,
  CircularProgress,
  Typography,
  Checkbox,
  DialogTitle,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import "../../styles/signUpDialog.css";
import InputStyle from "../../assets/InputStyle";
import ForgetPasswordModal from "./ForgetPasswordModal";
import { useState } from "react";
import SignUp from "./SignUp";
import { enqueueSnackbar } from "notistack";
import { isValidPhoneNumber, isValidateEmail } from "../../utils/common";
import { useDispatch } from "react-redux";
import { getUserInformation, login } from "../../actions/userAuth";
import CloseIcon from '@mui/icons-material/Close';

export default function LoginModal({ addLoginAction, setAddLoginAction }) {
  const [forgetPasswordAction, setForgetPasswordAction] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [passwordVisibility, setPasswordVisibility] = useState(false);

  const dispatch = useDispatch();

  const closeHandler = (event, reason) => {
    if (reason && reason == "backdropClick") return;
    setAddLoginAction(false);
  };

  const handlePasswordVisibility = (id, state, setState) => {
    if (state) {
      document.getElementById(id).type = "password";
    } else {
      document.getElementById(id).type = "text";
    }
    setState(!state);
  }

  const handleSubmit = () => {
    setLoading(true);
    if (!email || !password) {
      enqueueSnackbar("Please fill all the fields", { variant: "warning" });
      setLoading(false);
    } else if (isValidateEmail(email)) {
      dispatch(
        login(
          { email, password },
          (data) => {
            localStorage.setItem("rememberMe", rememberMe);
            localStorage.setItem("refreshToken", data.data.refresh_token);
            dispatch(getUserInformation({}, (data) => {
              dispatch({
                type: "LOG_IN",
                payload: data.data.data,
              });
              localStorage.setItem("user", JSON.stringify(data.data.data));
            }, (err) => {
              console.log(err);
            }, data.data.refresh_token
            ))
            enqueueSnackbar("Logged in successfully", { variant: "success" });
            setLoading(false);
            setAddLoginAction(false);
            setEmail("");
            setPassword("");
          },
          (err) => {
            enqueueSnackbar(err.response.data.msg, { variant: "error", });
            setLoading(false);
          }
        )
      );
    } else if (isValidPhoneNumber(email)) {
      dispatch(
        login(
          { email, password },
          (data) => {
            localStorage.setItem("rememberMe", rememberMe);
            localStorage.setItem("refreshToken", data.data.refresh_token);
            dispatch(getUserInformation({}, (data) => {
              dispatch({
                type: "LOG_IN",
                payload: data.data.data,
              });
              localStorage.setItem("user", JSON.stringify(data.data.data));
            }, (err) => {
              console.log(err);
            }, data.data.refresh_token
            ))
            enqueueSnackbar("Logged in successfully", { variant: "success" });
            setLoading(false);
            setAddLoginAction(false);
            setEmail("");
            setPassword("");
          },
          (err) => {
            enqueueSnackbar("Error occured! please try again", { variant: "error", });
            setLoading(false);
          }
        )
      );
    } else {
      enqueueSnackbar("Please enter a valid email or phone", { variant: "error", });
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog
        open={addLoginAction}
        onClose={closeHandler}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <CloseIcon sx={{ float: 'right', cursor: 'pointer' }} onClick={closeHandler} />
        </DialogTitle>
        <DialogContent>
          <Box px={6} py={3}>
            <Typography
              sx={{
                fontWeight: 700,
                mb: 4,
                textAlign: "center",
                color: "#2544EE",
                fontSize: 22,
                fontFamily: "Inter",
              }}
              component={"h3"}
            >
              Login
            </Typography>

            <Stack spacing={3} pt={1}>
              <InputStyle name="Email / Mobile Number" topSpace={true}>
                <input
                  type="text"
                  placeholder="Enter your email address / mobile number"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{color:'black',width:"100%",borderColor:'#BDC4CD'}}
                />
              </InputStyle>

              <InputStyle name="Password" topSpace={true}>
                <input
                 id={"password"}
                  type="password"
                  placeholder="Enter your password "
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{color:'black',width:"100%",borderColor:'#BDC4CD'}}
                />
                   {
                  passwordVisibility
                    ?
                    <Visibility onClick={() => handlePasswordVisibility("password", passwordVisibility, setPasswordVisibility)} style={{ marginLeft: '-30px', cursor: 'pointer' }} />
                    :
                    <VisibilityOff onClick={() => handlePasswordVisibility("password", passwordVisibility, setPasswordVisibility)} style={{ marginLeft: '-30px', cursor: 'pointer' }} />
                }
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <FormControlLabel
                    sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}
                    control={<Checkbox value={rememberMe} onChange={(e) => { setRememberMe(e.target.checked) }} />}
                    label="Remember me"
                  />

                  <a
                    onClick={() => {
                      setForgetPasswordAction(true);
                      closeHandler();
                    }}
                    style={{
                      textDecoration: "none",
                      color: "#2544EE",
                      cursor: "pointer",
                      marginRight: "1.50rem"
                    }}
                    className="text2Bold"
                  >
                    forget password
                  </a>
                </Box>
              </InputStyle>
             
              <Button
                disabled={loading}
                onClick={handleSubmit}
                variant="contained"
                fullWidth
                sx={{ bgcolor: "#2544EE", width:'100%', textTransform:'none',fontSize:16,borderRadius:2 }}
              >
                {
                  loading
                    ?
                    <CircularProgress size={24} />
                    :
                    " Login"
                }

              </Button>
            </Stack>
          </Box>
        </DialogContent>
      </Dialog>
      <ForgetPasswordModal
        forgetPasswordAction={forgetPasswordAction}
        setForgetPasswordAction={setForgetPasswordAction}
      />
    </>
  );
}
